import { useMutation, useQueryClient } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { components } from '@/schema'

type UpdateChatRoomStatusDtoStatus =
	components['schemas']['UpdateChatRoomStatusDto']['status']

export function useMutationUpdateRoomStatus() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			roomId,
			status,
		}: {
			roomId: string
			status: UpdateChatRoomStatusDtoStatus
		}) => chatService.updateRoomStatus(roomId, status),
		onSuccess: (data) => {
			// Update room in cache immediately for responsive UI
			queryClient.setQueryData(chatKeys.room(data.id), data)
			// SSE chat:room_updated + chat:room_list_changed handles rooms() invalidation
		},
	})
}
